var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sys-pop-over-config-base", {
        ref: "configBase",
        attrs: {
          model: _vm.model,
          configs: _vm.configs,
          errors: _vm.errors,
          title: "Validação da Atribuição",
          "tool-tip": "Validação da Atribuição",
        },
        on: { "menu-change": _vm.handleMenuChange },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function () {
              return [
                _c("emc-button-icon", {
                  attrs: { icon: "mdi-content-save", text: "Salvar e fechar" },
                  on: {
                    click: function ($event) {
                      return _vm.clickSave()
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }